/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { forwardRef, useCallback, type Ref } from 'react';
import CustomizeIcon from '@atlaskit/icon/core/customize';
import {
	ButtonMenuItem,
	type ButtonMenuItemProps,
} from '@atlaskit/side-nav-items/button-menu-item';
import { useFormattedMessageAndIcon } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/utils/use-formatted-message-and-icon/index.tsx';
import { useSectionItemAnalytics } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/utils/use-section-item-analytics/index.tsx';
import type { UIAnalyticsEvent } from '@atlassian/jira-product-analytics-bridge';
import { SECTION_ITEM_CUSTOMIZE_SIDEBAR } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/section-type.tsx';
/* eslint-disable jira/i18n/no-export-define-message */
/* eslint-disable jira/filename-case */
// eslint-disable-next-line no-restricted-imports
import { defineMessage } from '@atlassian/jira-intl';

const customizeSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebar-content.configurable-menu-items.sidebar-customization.customize-sidebar-menu-item.customize-sidebar',
	// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
	defaultMessage: 'Customize sidebar',
	description: 'Button text to open customization dialog',
});

export type CustomizeSidebarMenuItemProps = Partial<ButtonMenuItemProps>;

export const CustomizeSidebarMenuItem: React.ForwardRefExoticComponent<
	Partial<ButtonMenuItemProps> & React.RefAttributes<HTMLButtonElement>
> = forwardRef(
	(
		{ onClick, ...props }: CustomizeSidebarMenuItemProps,
		ref: Ref<HTMLButtonElement> | undefined,
	) => {
		const { formattedMessage, icon } = useFormattedMessageAndIcon(customizeSidebar, CustomizeIcon);
		const sendSectionItemAnalyticsEvent = useSectionItemAnalytics();

		const onClickHandler = useCallback(
			(event: React.MouseEvent<HTMLButtonElement>, analyticsEvent: UIAnalyticsEvent) => {
				sendSectionItemAnalyticsEvent({
					sectionItem: SECTION_ITEM_CUSTOMIZE_SIDEBAR,
				});
				onClick?.(event, analyticsEvent);
			},
			[onClick, sendSectionItemAnalyticsEvent],
		);

		return (
			<ButtonMenuItem
				{...props}
				interactionName="nav4-sidebar-customise-modal"
				elemBefore={icon}
				onClick={onClickHandler}
				ref={ref}
			>
				{formattedMessage}
			</ButtonMenuItem>
		);
	},
);
